<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES6NUC3']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6NUC3']['100'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6NUC3']['110'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-100" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6NUC3']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-100" id="coddesc_codleave" name="coddesc_codleave">{{ detail.tab1.codleave }} - {{ detail.tab1.desc_codleave }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6NUC3']['40'] }} - {{ labels['HRES6NUC3']['60'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-100" id="dteBtw" name="dteBtw">{{ setDateOutput(detail.tab1.dtestrt) }} - {{ setDateOutput(detail.tab1.dteend) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6NUC3']['30'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-100 txtarea-width response-full-width" id="remark" name="remark">{{ detail.tab1.remark }}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres6nu-detail',
  props: [ 'labels', 'detail', 'toggle', 'currentDtereq', 'currentNumseq', 'currentCodempid', 'data', 'indexSelected', 'nowLang', 'labelsButton' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?c1146ac0